import { rem } from 'polished';
import React, { memo } from 'react';
import styled from 'styled-components';
import { borderRadius, boxShadow } from 'styled-system';
import Box from './Box';
import theme from './theme';
const StyledOverlayContent = styled(Box).withConfig({
  displayName: "OverlayContent__StyledOverlayContent",
  componentId: "sc-1lfq578-0"
})(["", " ", ""], borderRadius, boxShadow);
const OverlayContent = /*#__PURE__*/memo(_ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledOverlayContent, props, children);
});
OverlayContent.propTypes = {
  ...Box.propTypes,
  ...borderRadius.propTypes,
  ...boxShadow.propTypes
};
OverlayContent.defaultProps = {
  bg: theme.colors.gray[1],
  my: rem(80),
  mx: 'auto',
  p: [3, 4],
  width: '95%',
  boxShadow: 'hover',
  borderRadius: 'corner'
};
OverlayContent.displayName = 'OverlayContent';
export default OverlayContent;